import ga from './src/ga';

export const AnalyticsGA = ga;

export default { AnalyticsGA };
